export enum Status {
  New,
  Invited,
  Active,
  Archived,
}
